import React from 'react'
import { useTranslation } from 'react-i18next'
import FormalityStepButton from '../FormalityStepButton'

interface IProps {
  onFinish: any
  loading?: boolean
}

const AuthorityRedropConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { onFinish, loading = false } = props

  const handleFinishRedrop = () => {
    onFinish({
      authorityRedrop: true,
    })
  }

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.redrop.title')}
        description={t('show.form.submit.confirm.redrop.description')}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.redrop.label')}
        onConfirm={() => handleFinishRedrop()}
      />
    </>
  )
}

export default AuthorityRedropConfirm
